import { PLATFORM_TENANT_ID } from "@zero/idaas-api";

/** Opaque identifier for a validated IDAAS tenant. */
declare const tenantIdBrand: unique symbol;

/** Canonical UUIDv7 tenant identifier or the reserved platform Tenant ID. */
export type TenantId = string & { readonly [tenantIdBrand]: "TenantId" };

const UUID_V7_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;

/** Parse an untrusted wire or storage value into a validated tenant identifier. */
export function parseTenantId(value: unknown): TenantId | null {
  if (typeof value !== "string" || (value !== PLATFORM_TENANT_ID && !UUID_V7_PATTERN.test(value))) return null;
  return value as TenantId;
}
